import { Minus, Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/utils/cn';

export const SeatCountStepper = ({
  id,
  value,
  min,
  onChange,
  decreaseLabel,
  increaseLabel,
  className,
}: {
  id: string;
  value: number;
  min: number;
  onChange: (value: number) => void;
  decreaseLabel: string;
  increaseLabel: string;
  className?: string;
}) => (
  <div className={cn('flex items-center gap-1', className)}>
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="h-9 w-9 shrink-0 border-brand/30"
      disabled={value <= min}
      aria-label={decreaseLabel}
      onClick={() => onChange(Math.max(min, value - 1))}
    >
      <Minus className="size-4" aria-hidden />
    </Button>
    <span
      id={id}
      className="min-w-10 text-center text-body-sm font-semibold tabular-nums text-fg"
      aria-live="polite"
    >
      {value}
    </span>
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="h-9 w-9 shrink-0 border-brand/30"
      aria-label={increaseLabel}
      onClick={() => onChange(value + 1)}
    >
      <Plus className="size-4" aria-hidden />
    </Button>
  </div>
);
